module.exports = __webpack_public_path__ + "img/1F1EA-1F1EC.e815ef58.svg";